import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'audioSubType';

export class AudioSubType extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
